import {ListItem} from '../model/ListItem'

const fields = {
    jytkycxssygx: {
        title: "学士学位授予高校查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'name', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxdm', label: '学校代码'}),
                new ListItem({prop: 'name', label: '学校名称'}),
                new ListItem({prop: 'bxdz', label: '学校地址'}),
                new ListItem({prop: 'xxwz', label: '学校网址'}),
                new ListItem({prop: 'bxxz', label: '办学性质'}),
                new ListItem({prop: 'lsgx', label: '隶属关系'})]
        }]
    },
    jytkylxbkxsxw: {
        title: "留学生学士学位查询",
        areaCode: "510000",
        labelWidth: null,
        key:'48051e5855e14f51bcaa57552a909388',
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证件号码', prop: 'zjhm', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'gbm', label: '国别码'}),
                new ListItem({prop: 'gb', label: '国别'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'zjlxm', label: '证件类型码'}),
                new ListItem({prop: 'zjlx', label: '证件类型'}),
                new ListItem({prop: 'zjhm', label: '证件号码'}),
                new ListItem({prop: 'xwsydwm', label: '学位授予单位码'}),
                new ListItem({prop: 'xwsydw', label: '学位授予单位名称'}),
                new ListItem({prop: 'xwlbm', label: '学位类别码'}),
                new ListItem({prop: 'xwlb', label: '学位类别名称'}),
                new ListItem({prop: 'zydm', label: '专业代码'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'zszymc', label: '自设专业名称'}),
                new ListItem({prop: 'rxny', label: '入学年月'}),
                new ListItem({prop: 'hxwrq', label: '获学位日期'}),
                new ListItem({prop: 'xwzsbh', label: '学位证书编号'})]
        }]
    },
    jytkyptbkxsxw: {
        title: "学士学术学位查询",
        areaCode: "510000",
        key:'73f155e2ba6b4600beaa918e060b353d',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({
                    label: '证件号码', prop: 'zjhm',
                    comType: 'text',
                    listName: 'sex',
                    edit: true,
                    required: true,
                    maxlength: 18
                })]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'mz', label: '民族'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'zjhm', label: '身份证号码'}),
                new ListItem({prop: 'xwsydwm', label: '学位授予单位码'}),
                new ListItem({prop: 'xwsydw', label: '学位授予单位名称'}),
                new ListItem({prop: 'xwlbm', label: '学位类别码'}),
                new ListItem({prop: 'xwlb', label: '学位类别名称'}),
                new ListItem({prop: 'zydm', label: '专业代码'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'zszymc', label: '自设专业名称'}),
                new ListItem({prop: 'rxny', label: '入学年月'}),
                new ListItem({prop: 'hxwrq', label: '获学位日期'}),
                new ListItem({prop: 'xwzsbh', label: '学位证书编号'})]
        }]
    },
    jytkycxszyxw: {
        title: "学士专业学位查询",
        key:'b8059332c58e46f4ad215ff772990674',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证件号码', prop: 'zjhm', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'mz', label: '民族'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'zjhm', label: '身份证号码'}),
                new ListItem({prop: 'xwsydwm', label: '学位授予单位码'}),
                new ListItem({prop: 'xwsydw', label: '学位授予单位名称'}),
                new ListItem({prop: 'xwlbm', label: '学位类别码'}),
                new ListItem({prop: 'xwlb', label: '学位类别名称'}),
                new ListItem({prop: 'rxny', label: '入学年月'}),
                new ListItem({prop: 'hxwrq', label: '获学位日期'}),
                new ListItem({
                    prop: 'xwzsbh', label: '学位证书编号'
                })]
        }]
    },
    jytkycrbkxsxw: {
        title: "成人本科学士学位查询",
        areaCode: "510000",
        key:'94184aa2c85c48be886cf1fefa494510',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证件号码', prop: 'zjhm', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'mz', label: '民族'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'zjhm', label: '份证号码'}),
                new ListItem({prop: 'xwsydwm', label: '学位授予单位码'}),
                new ListItem({prop: 'xwsydw', label: '学位授予单位名称'}),
                new ListItem({prop: 'xwlbm', label: '学位类别码'}),
                new ListItem({prop: 'xwlb', label: '学位类别名称'}),
                new ListItem({prop: 'zydm', label: '专业代码'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'zszymc', label: '自设专业名称'}),
                new ListItem({prop: 'rxny', label: '入学年月'}),
                new ListItem({prop: 'hxwrq', label: '获学位日期'}),
                new ListItem({prop: 'xwzsbh', label: '学位证书编号'})]
        }]
    },
    jytkycssgx: {
        title: "研究生培养高校查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxdm', label: '学校代码'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'bxdz', label: '学校地址'}),
                new ListItem({prop: 'xxwz', label: '学校网址'}),
                new ListItem({prop: 'bxxz', label: '办学性质'}),
                new ListItem({prop: 'lsgx', label: '隶属关系'})]
        }]
    },
    jytkycsszyxw: {
        title: "硕士专业学位查询",
        areaCode: "510000",
        key:'4fd51fe527804142be03fa70b3c2126b',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证件号码', prop: 'zjhm', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'mz', label: '民族'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'zjhm', label: '身份证号码'}),
                new ListItem({prop: 'xwsydwm', label: '学位授予单位码'}),
                new ListItem({prop: 'xwsydw', label: '学位授予单位名称'}),
                new ListItem({prop: 'xwlbm', label: '学位类别码'}),
                new ListItem({prop: 'xwlb', label: '学位类别名称'}),
                new ListItem({prop: 'zyxwlym', label: '专业学位领域码'}),
                new ListItem({prop: 'zyxwly', label: '专业学位领域名称'}),
                new ListItem({prop: 'rxny', label: '入学年月'}),
                new ListItem({prop: 'hxwrq', label: '获学位日期'}),
                new ListItem({prop: 'xwzsbh', label: '学位证书编号'})]
        }]
    },
    jytkyctdxlss: {
        title: "同等学力硕士学位查询",
        areaCode: "510000",
        key:'f972cd0e2461474580f549811ead0356',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证件号码', prop: 'zjhm', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'zszydm', label: '自设专业代码'}),
                new ListItem({prop: 'zszymc', label: '自设专业名称'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'mz', label: '民族'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'zjhm', label: '身份证号码'}),
                new ListItem({prop: 'xwsydwm', label: '学位授予单位码'}),
                new ListItem({prop: 'xwsydw', label: '学位授予单位名称'}),
                new ListItem({prop: 'xwlbm', label: '学位类别码'}),
                new ListItem({prop: 'xwlb', label: '学位类别名称'}),
                new ListItem({prop: 'yjxksy', label: '一级学科授予'}),
                new ListItem({prop: 'yjxkdm', label: '一级学科代码'}),
                new ListItem({prop: 'yjxkmc', label: '一级学科名称'}),
                new ListItem({prop: 'zydm', label: '专业代码'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'hxwrq', label: '获学位日期'}),
                new ListItem({prop: 'xwzsbh', label: '学位证书编号'})]
        }]
    },
    jytkycxljyss: {
        title: "硕士学术学位查询",
        key:'a79614a6f0a04c9dba088c9bf1f279e6',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证件号码', prop: 'zjhm', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'mz', label: '民族'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'zjhm', label: '身份证号码'}),
                new ListItem({prop: 'xwsydwm', label: '学位授予单位码'}),
                new ListItem({prop: 'xwsydw', label: '学位授予单位名称'}),
                new ListItem({prop: 'yjxksy', label: '一级学科授予'}),
                new ListItem({prop: 'xwlbm', label: '学位类别码'}),
                new ListItem({prop: 'xwlb', label: '学位类别名称'}),
                new ListItem({prop: 'zydm', label: '专业代码'}),
                new ListItem({prop: 'yjxkdm', label: '一级学科代码'}),
                new ListItem({prop: 'yjxkmc', label: '一级学科名称'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'zszydm', label: '自设专业代码'}),
                new ListItem({prop: 'zszymc', label: '自设专业名称'}),
                new ListItem({prop: 'rxny', label: '入学年月'}),
                new ListItem({prop: 'hxwrq', label: '获学位日期'})]
        }]
    },
    jytxscssyjsxlxx: {
        title: "硕士生学历信息查询",
        key:'14a8a820f6404fa6bba15ebe8c7edcee',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证书编号', prop: 'zsbh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'rxrq', label: '入学日期'}),
                new ListItem({prop: 'byrq', label: '毕业日期'}),
                new ListItem({prop: 'yxmc', label: '院校名称'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'xllb', label: '学历类别'}),
                new ListItem({prop: 'sz', label: '学制'}),
                new ListItem({prop: 'xxxs', label: '学习形式'}),
                new ListItem({prop: 'cc', label: '层次'}),
                new ListItem({prop: 'bjyjl', label: '毕结业结论'}),
                new ListItem({prop: 'xzm', label: '校长名'}),
                new ListItem({prop: 'zsbh', label: '证书编号'})]
        }]
    },
    jytkycbsgx: {
        title: "博士学位授予高校查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxdm', label: '学校代码'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'bxdz', label: '学校地址'}),
                new ListItem({prop: 'xxwz', label: '学校网址'}),
                new ListItem({prop: 'bxxz', label: '办学性质'}),
                new ListItem({prop: 'lsgx', label: '隶属关系'})]
        }]
    },
    jytkycxljybs: {
        title: "博士学术学位查询",
        key:'1858e871d7a84107a4aeb6a2a155a348',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证件号码', prop: 'zjhm', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'mz', label: '民族'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'zjhm', label: '身份证号码'}),
                new ListItem({prop: 'xwsydwm', label: '学位授予单位码'}),
                new ListItem({prop: 'xwsydw', label: '学位授予单位名称'}),
                new ListItem({prop: 'xwlbm', label: '学位类别码'}),
                new ListItem({prop: 'xwlb', label: '学位类别名称'}),
                new ListItem({prop: 'yjxksy', label: '一级学科授予'}),
                new ListItem({prop: 'zydm', label: '专业代码'}),
                new ListItem({prop: 'yjxkdm', label: '一级学科代码'}),
                new ListItem({prop: 'yjxkmc', label: '一级学科名称'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'zszydm', label: '自设专业代码'}),
                new ListItem({prop: 'zszymc', label: '自设专业名称'}),
                new ListItem({prop: 'rxny', label: '入学年月'}),
                new ListItem({prop: 'hxwrq', label: '获学位日期'}),
                new ListItem({prop: 'xwzsbh', label: '学位证书编号'})]
        }]
    },
    jytkycbszyxw: {
        title: "博士专业学位查询",
        key:'6c79c50314ec4208943643caaad3f663',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证件号码', prop: 'zjhm', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'mz', label: '民族'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'zjhm', label: '身份证号码'}),
                new ListItem({prop: 'xwsydwm', label: '学位授予单位码'}),
                new ListItem({prop: 'xwsydw', label: '学位授予单位名称'}),
                new ListItem({prop: 'xwlbm', label: '学位类别码'}),
                new ListItem({prop: 'xwlb', label: '学位类别名称'}),
                new ListItem({prop: 'zyxwlym', label: '专业学位领域码'}),
                new ListItem({prop: 'zyxwly', label: '专业学位领域名称'}),
                new ListItem({prop: 'rxny', label: '入学年月'}),
                new ListItem({prop: 'hxwrq', label: '获学位日期'}),
                new ListItem({prop: 'xwzsbh', label: '学位证书编号'})]
        }]
    },
    jytkyctdxlbs: {
        title: "同等学力博士学位查询",
        areaCode: "510000",
        key:'9e93ae93c8ed4932ac104f4c950d2ea3',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证件号码', prop: 'zjhm', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'mz', label: '民族'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'zjhm', label: '身份证号码'}),
                new ListItem({prop: 'xwsydwm', label: '学位授予单位码'}),
                new ListItem({prop: 'xwsydw', label: '学位授予单位名称'}),
                new ListItem({prop: 'xwlbm', label: '学位类别码'}),
                new ListItem({prop: 'xwlb', label: '学位类别名称'}),
                new ListItem({prop: 'yjxksy', label: '一级学科授予'}),
                new ListItem({prop: 'yjxkdm', label: '一级学科代码'}),
                new ListItem({prop: 'yjxkmc', label: '一级学科名称'}),
                new ListItem({prop: 'zydm', label: '专业代码'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'zszydm', label: '自设专业代码'}),
                new ListItem({prop: 'zszymc', label: '自设专业名称'}),
                new ListItem({prop: 'hxwrq', label: '获学位日期'}),
                new ListItem({prop: 'xwzsbh', label: '学位证书编号'})]
        }]
    },
    jytxscbsyjsxlxx: {
        title: "博士生学历信息查询",
        areaCode: "510000",
        key:'b195d22d06f4415bb398be7cd6d4e9e0',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证书编号', prop: 'zsbh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'rxrq', label: '入学日期'}),
                new ListItem({prop: 'byrq', label: '毕业日期'}),
                new ListItem({prop: 'yxmc', label: '院校名称'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'xllb', label: '学历类别'}),
                new ListItem({prop: 'sz', label: '学制'}),
                new ListItem({prop: 'xxxs', label: '学习形式'}),
                new ListItem({prop: 'cc', label: '层次'}),
                new ListItem({prop: 'bjyjl', label: '毕结业结论'}),
                new ListItem({prop: 'xzm', label: '校长名'}),
                new ListItem({prop: 'zsbh', label: '证书编号'})]
        }]
    },
    jytxscptbk: {
        title: "普通本科学历信息查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'aa35e71b8c7f485fa89768e1b5374f4b',
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证书编号', prop: 'zsbh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'rxrq', label: '入学日期'}),
                new ListItem({prop: 'byrq', label: '毕业日期'}),
                new ListItem({prop: 'yxmc', label: '院校名称'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'xllb', label: '学历类别'}),
                new ListItem({prop: 'xz', label: '学制'}),
                new ListItem({prop: 'xxxs', label: '学习形式'}),
                new ListItem({prop: 'cc', label: '层次'}),
                new ListItem({prop: 'bjyjl', label: '毕结业结论'}),
                new ListItem({prop: 'xzm', label: '校长名'}),
                new ListItem({prop: 'zsbh', label: '证书编号'})]
        }]
    },
    jytxscptzkxsxlxx: {
        title: "普通专科学历信息查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证书编号', prop: 'zsbh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'rxrq', label: '入学日期'}),
                new ListItem({prop: 'byrq', label: '毕业日期'}),
                new ListItem({prop: 'yxmc', label: '院校名称'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'xllb', label: '学历类别'}),
                new ListItem({prop: 'xz', label: '学制'}),
                new ListItem({prop: 'xxxs', label: '学习形式'}),
                new ListItem({prop: 'cc', label: '层次'}),
                new ListItem({prop: 'bjyjl', label: '毕结业结论'}),
                new ListItem({prop: 'xzm', label: '校长名'}),
                new ListItem({prop: 'zsbh', label: '证书编号'})]
        }]
    },
    jytxscwljybk: {
        title: "网教本科学历信息查询",
        areaCode: "510000",
        key:'42016b35009842af97a8e23295505657',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证书编号', prop: 'zsbh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'rxrq', label: '入学日期'}),
                new ListItem({prop: 'byrq', label: '毕业日期'}),
                new ListItem({prop: 'yxmc', label: '院校名称'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'xllb', label: '学历类别'}),
                new ListItem({prop: 'xz', label: '学制'}),
                new ListItem({prop: 'xxxs', label: '学习形式'}),
                new ListItem({prop: 'cc', label: '层次'}),
                new ListItem({prop: 'bjyjl', label: '毕结业结论'}),
                new ListItem({prop: 'xzm', label: '校长名'}),
                new ListItem({prop: 'zsbh', label: '证书编号'})]
        }]
    },
    jytxscwljyzk: {
        title: "网教专科学历信息查询",
        key:'dce20680996e4ec9acef4c16087982f5',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证书编号', prop: 'zsbh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'rxrq', label: '入学日期'}),
                new ListItem({prop: 'byrq', label: '毕业日期'}),
                new ListItem({prop: 'yxmc', label: '院校名称'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'xllb', label: '学历类别'}),
                new ListItem({prop: 'xz', label: '学制'}),
                new ListItem({prop: 'xxxs', label: '学习形式'}),
                new ListItem({prop: 'cc', label: '层次'}),
                new ListItem({prop: 'bjyjl', label: '毕结业结论'}),
                new ListItem({prop: 'xzm', label: '校长名'}),
                new ListItem({prop: 'zsbh', label: '证书编号'})]
        }]
    },
    jyttwycystsxx: {
        title: "艺术特色学校查询",
        key:'7727e8aedd5d4a3e99f1564537015755',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 160, list: [
                new ListItem({label: '学校名称或市（州）', prop: 'xxmcORsz', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxch', label: '学校称号'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'hpnf', label: '获批年份'}),
                new ListItem({prop: 'sz', label: '市（州）'})]
        }]
    },
    jyttwycgfjytsxx: {
        title: "国防教育特色学校查询",
        key:'84715d0eab57424b9f03ec38626408d2',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 160, list: [
                new ListItem({label: '学校名称或市（州）', prop: 'xxmcORsz', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxch', label: '学校称号'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'hpnf', label: '获批年份'}),
                new ListItem({prop: 'sz', label: '市（州）'})]
        }]
    },
    jyttwyctytsxx: {
        title: "体育特色学校查询",
        key:'786794ba9aff45c7a9d4ba6c5cd6e002',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 160, list: [
                new ListItem({label: '学校名称或市（州）', prop: 'xxmcORsz', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxch', label: '学校称号'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'hpnf', label: '获批年份'}),
                new ListItem({prop: 'sz', label: '市（州）'})]
        }]
    },
    jyttwycxyzqtsxx: {
        title: "校园足球特色学校查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 160, list: [
                new ListItem({label: '学校名称或市（州）', prop: 'xxmcORsz', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxch', label: '学校称号'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'hpnf', label: '获批年份'}),
                new ListItem({prop: 'sz', label: '市（州）'})]
        }]
    },
    jytfzghctsjyxxxx: {
        title: "特殊教育学校查询",
        key:'3bff4185d1fc44b1aebd4e28d5dc2659',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxxz', label: '办学性质'})]
        }]
    },
    jytttwycxyzqxlyzj: {
        title: "省级校园足球最佳阵容查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '身份证号', prop: 'sfzh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'sfzh', label: '身份证号'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'rxsjdxx', label: '入选时就读学校'}),
                new ListItem({prop: 'rxnf', label: '入选年份'}),
                new ListItem({prop: 'rxzb', label: '入选组别'}),
                new ListItem({prop: 'sz', label: '市（州）'}),
                new ListItem({prop: 'ydydj', label: '运动员等级'})]
        }]
    },
    jyttwycqgxyzqxly: {
        title: "全国校园足球最佳阵容查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '身份证号', prop: 'sfzh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'sfzh', label: '身份证号'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'rxsjdxx', label: '入选时就读学校'}),
                new ListItem({prop: 'rxnf', label: '入选年份'}),
                new ListItem({prop: 'rxzb', label: '入选组别'}),
                new ListItem({prop: 'sz', label: '市（州）'}),
                new ListItem({prop: 'ydydj', label: '运动员等级'})]
        }]
    },
    jytrsjscjybsf: {
        title: "师范专业认证名单查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'3c1f06e66d764e7daf814126c7d08b01',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'cc', label: '层次'}),
                new ListItem({prop: 'zylb', label: '专业类别'}),
                new ListItem({prop: 'rzjl', label: '认证记录'}),
                new ListItem({prop: 'yxqkssj', label: '有效期开始时间'}),
                new ListItem({prop: 'yxqjssj', label: '有效期结束时间'})]
        }]
    },
    jytrsjscgjjzyjy: {
        key:'b2c88eddbe29448e97d50fdd8b496eee',
        title: "国家职教创新团队查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'zyly', label: '专业领域'}),
                new ListItem({prop: 'zyfx', label: '专业分类'}),
                new ListItem({prop: 'pc', label: '批次'}),

            ]
        }]
    },
    jytrsjscsjjzyjy: {
        title: "省级职教创新团队查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'7f2f0841423c41ecb0cbd984adb5afc0',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'tdzy', label: '团队专业'}),
                new ListItem({prop: 'fzr', label: '负责人'}),
                new ListItem({prop: 'zyjzw', label: '专业及职称（职务）'})]
        }]
    },
    jyttwyczhyxctw: {
        title: "中华优秀传统文化传承基地查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 160, list: [
                new ListItem({label: '学校名称或市（州）', prop: 'xxmcORsz', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxch', label: '学校称号'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'hpnf', label: '获批年份'}),
                new ListItem({prop: 'sz', label: '市（州）'}),
                new ListItem({prop: 'ccxm', label: '传承项目'})]
        }]
    },
    jytsksyjszgz: {
        title: "教师资格考试成绩",
        key:'56a793bd15e04840950024bac9f951c7',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '身份证件号', prop: 'zjhm', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'zjhm', label: '身份证件号'}),
                new ListItem({prop: 'zkzh', label: '准考证号'}),
                new ListItem({prop: 'bscj', label: '笔试成绩'}),
                new ListItem({prop: 'mskm', label: '面试科目'}),
                new ListItem({prop: 'mscj', label: '面试成绩'}),
                new ListItem({prop: 'kssf', label: '考试省份'}),
                new ListItem({prop: 'pc', label: '批次'})]
        }]
    },
    jytshmbcxwpxhmd: {
        title: "校外培训机构黑名单查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'10e6d275d5b647d1bb2c11044e0b125a',
        searchFields: [{
            labelWidth: 160, list: [
                new ListItem({label: '机构名称或地区', prop: 'jgmcORdq', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'jgmc', label: '机构名称'}),
                new ListItem({prop: 'lx', label: '类型'}),
                new ListItem({prop: 'dq', label: '地区'}),
                new ListItem({prop: 'dz', label: '实际经营地址'})]
        }]
    },
    jytshmbcxwpxbmd: {
        title: "校外培训机构白名单查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'37f8174279b74b16b31de22884e09c3a',
        searchFields: [{
            labelWidth: 160, list: [
                new ListItem({label: '机构名称或地区', prop: 'jgmcORdq', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'jgmc', label: '机构名称'}),
                new ListItem({prop: 'dq', label: '地区'}),
                new ListItem({prop: 'sjjydz', label: '实际经营地址'}),
                new ListItem({prop: 'pxlb', label: '培训类别'}),
                new ListItem({prop: 'xz', label: '校长'}),
                new ListItem({prop: 'pxddh', label: '培训点电话'})]
        }]
    },
    jytshmbcxwpxjg: {
        title: "校外培训机构信息查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'cf0501e738c14c5096c0212a3cc2e0ea',
        searchFields: [{
            labelWidth: 160, list: [
                new ListItem({label: '机构名称或地区', prop: 'jgmcORdq', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'jgmc', label: '机构名称'}),
                new ListItem({prop: 'dq', label: '地区'}),
                new ListItem({prop: 'sjjydz', label: '实际经营地址'}),
                new ListItem({prop: 'pxlb', label: '培训类别'}),
                new ListItem({prop: 'xz', label: '校长'}),
                new ListItem({prop: 'pxddh', label: '培训点电话'})]
        }]
    },
    jytsksyzczscrgd: {
        title: "成人高校名单查询",
        areaCode: "510000",
        key:'ad9dbc2a370b41719077db8592beba6c',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 120, list: [
                new ListItem({label: '院校名称', prop: 'yxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'yxdm', label: '院校代码'}),
                new ListItem({prop: 'yxmc', label: '院校名称'}),
                new ListItem({prop: 'zgbm', label: '主管部门'}),
                new ListItem({prop: 'yxdz', label: '院校地址'}),
                new ListItem({prop: 'zsnd', label: '招生年度'})]
        }]
    },
    jytsksygdjyzxk: {
        title: "自考应用型专业查询",
        areaCode: "510000",
        labelWidth: null,
        key:'a1163b78dd144e89beaa127aaececeda',
        provenance: "",
        searchFields: [{
            labelWidth: 200, list: [
                new ListItem({label: '主考学校名称或主考专业', prop: 'zkxxmcORzkzy', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'zkxxmc', label: '主考学校名称'}),
                new ListItem({prop: 'zylx', label: '专业类型'}),
                new ListItem({prop: 'zkzy', label: '主考专业'}),
                new ListItem({
                    prop: 'lxdh', label: '联系电话与联系人'
                })]
        }]
    },
    jytsksyzczsptgd: {
        title: "普通高校名单查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'8f8af436e2c3480aa98a11bfd65a3a54',
        searchFields: [{
            labelWidth: 120, list: [
                new ListItem({label: '院校名称', prop: 'yxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'yxdm', label: '院校代码'}),
                new ListItem({prop: 'yxmc', label: '院校名称'}),
                new ListItem({prop: 'zgbm', label: '主管部门'}),
                new ListItem({prop: 'yxdz', label: '院校地址'}),
                new ListItem({prop: 'zsnd', label: '招生年度'})]
        }]
    },
    jytzjcgznd: {
        title: "年度招生高职专业查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 160, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'zydm', label: '专业代码'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'xynx', label: '修业年限'}),
            ]
        }]
    },
    jytgjcgdjxyxcgj: {
        title: "教学成果奖查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 120, list: [
                new ListItem({label: '所属单位', prop: 'ssdw', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'nd', label: '年度'}),
                new ListItem({prop: 'xmmc', label: '项目名称'}),
                new ListItem({prop: 'wcry', label: '完成人员'}),
                new ListItem({prop: 'ssdw', label: '所属单位'}),
                new ListItem({prop: 'cgdj', label: '成果等级'})]
        }]
    },
    jytfzghcptgdxxxx: {
        title: "普通高校查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxcc', label: '办学层次'}),
                new ListItem({prop: 'dsgx', label: '隶属关系'}),
                new ListItem({prop: 'bz', label: '备注'})]
        }]
    },
    jytjyzdzxscsgx: {
        title: "高校就业统计信息查询",
        key:'d58d84f8e73342e083df2e7c9db0dc8d',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 120, list: [
                new ListItem({label: '毕业年份', prop: 'bynf', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 120,
            colNum: 2,
            list: [
                new ListItem({prop: 'bynf', label: '毕业年份'}),
                new ListItem({prop: 'sjtjjzsj', label: '数据统计截止时间'}),
                new ListItem({prop: 'ztbysrs', label: '总体毕业生人数'}),
                new ListItem({prop: 'ztbyqxlsl', label: '总体毕业去向落实率'}),
                new ListItem({prop: 'yjsbysrs', label: '研究生毕业生人数'}),
                new ListItem({prop: 'yjsbyqxlsl', label: '研究生毕业去向落实率'}),
                new ListItem({prop: 'bksbysrs', label: '本科生毕业生人数'}),
                new ListItem({prop: 'bksbyqxlsl', label: '本科生毕业去向落实率'}),
                new ListItem({prop: 'zksbysrs', label: '专科生毕业生人数'}),
                new ListItem({prop: 'zksbyqxlsl', label: '专科生毕业去向落实率'})]
        }]
    },
    jytzjcndzzjyzs: {
        title: "年度招生中职学校查询",
        areaCode: "510000",
        labelWidth: null,
        key:'62ce5c8d0a1948048d293b5c87a80fe0',
        provenance: "",
        searchFields: [{
            labelWidth: 160, list: [
                new ListItem({label: '学校名称或地市', prop: 'xxmcOrds', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'dm', label: '代码'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'bm', label: '部门'}),
                new ListItem({prop: 'ds', label: '地市'}),
                new ListItem({prop: 'xxdz', label: '学校地址'}),
                new ListItem({prop: 'lxdh', label: '联系电话'}),
            ]
        }]
    },
    jytzjcndzzjy: {
        title: "年度招生中职专业查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'c89d3f93b26348898d938705f73921ac',
        searchFields: [{
            labelWidth: 160, list: [
                new ListItem({label: '学校名称或地市', prop: 'xxmcOrds', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'dm', label: '代码'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'bm', label: '部门'}),
                new ListItem({prop: 'ds', label: '地市'}),
                new ListItem({prop: 'xxdz', label: '学校地址'}),
                new ListItem({prop: 'lxdh', label: '联系电话'}),
                new ListItem({prop: 'kszy', label: '开设专业'}),
            ]
        }]
    },
    jytzjcsszdzyxx: {
        title: "省属中职学校信息查询",
        areaCode: "510000",
        labelWidth: null,
        key:'ce5b1fe4dc8b4727aca4f517fd08b483',
        provenance: "",
        searchFields: [{
            labelWidth: 120, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxdz', label: '学校地址'}),
                new ListItem({prop: 'lxdh', label: '联系电话'})]
        }]
    },
    jytdwcwjznxx: {
        key:'444c6ab9404d4c9382f5a8320e3bee21',
        title: "外籍人员子女学校查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '项目（机构）名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 120,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'bxdz', label: '办学地址'}),
                new ListItem({prop: 'sfzsbx', label: '是否招生办学'}),
                new ListItem({prop: 'kbjg', label: '开办机构（个人）'}),
                new ListItem({prop: 'kbsj', label: '学校开办时间和审批部门（以批文为准）'}),
                new ListItem({prop: 'fr', label: '法定代表人（姓名、国籍）'}),
                new ListItem({prop: 'bxzz', label: '办学资金来源'}),
                new ListItem({prop: 'bxcc', label: '办学层次（幼儿园、小学、初中、高中）'}),
                new ListItem({prop: 'zxsrs', label: '现有在校学生数'}),
                new ListItem({prop: 'sysl', label: '生源数量排名前5国家'}),
                new ListItem({prop: 'zsqk', label: '否招收中国籍学生（含港澳台地区）'}),
                new ListItem({prop: 'jzgs', label: '教职工总数（注明非中国籍教职工人数）'}),
                new ListItem({prop: 'kskc', label: '开设课程（国别课程、国际课程等）'}),
                new ListItem({prop: 'yyzk', label: '学校运营状况及困难'})]
        }]
    },
    jytdwczkzwhb: {
        title: "本科中外合作办学查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '项目（机构）名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 120,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '项目（机构）名称'}),
                new ListItem({prop: 'pzsj', label: '项目批准日期'}),
                new ListItem({prop: 'zghzz', label: '中方合作者'}),
                new ListItem({prop: 'jbdd', label: '举办地点'}),
                new ListItem({prop: 'wfxx', label: '外方合作者及英文名称及世界排名情况'}),
                new ListItem({prop: 'gj', label: '国别（地区）'}),
                new ListItem({prop: 'cc', label: '层次'}),
                new ListItem({prop: 'zsfs', label: '招生方式'}),
                new ListItem({prop: 'zsrs', label: '批准每年招生人数'}),
                new ListItem({prop: 'lx', label: '类型'}),
                new ListItem({prop: 'zfzs', label: '中方证书'}),
                new ListItem({prop: 'wfzs', label: '外方证书'}),
                new ListItem({prop: 'yxq', label: '协议有效期'}),
                new ListItem({prop: 'zy', label: '学科（专业）'})]
        }]
    },
    jytdwcbkzwhb: {
        title: "专科中外合作办学查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '项目（机构）名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 120,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '项目（机构）名称'}),
                new ListItem({prop: 'pzsj', label: '项目批准日期'}),
                new ListItem({prop: 'zghzz', label: '中方合作者'}),
                new ListItem({prop: 'jbdd', label: '举办地点'}),
                new ListItem({prop: 'wfxx', label: '外方合作者及英文名称及世界排名情况'}),
                new ListItem({prop: 'gj', label: '国别（地区）'}),
                new ListItem({prop: 'cc', label: '层次'}),
                new ListItem({prop: 'zsfs', label: '招生方式'}),
                new ListItem({prop: 'zsrs', label: '批准每年招生人数'}),
                new ListItem({prop: 'lx', label: '类型'}),
                new ListItem({prop: 'zfzs', label: '中方证书'}),
                new ListItem({prop: 'wfzs', label: '外方证书'}),
                new ListItem({prop: 'zy', label: '学科（专业）'})]
        }]
    },
    jytdwczwgpzs: {
        title: "中外合作办学项目批准书查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '项目（机构）名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 120,
            colNum: 2,
            list: [
                new ListItem({prop: 'pzsbh', label: '许可证编号'}),
                new ListItem({prop: 'xmmc', label: '项名称'}),
                new ListItem({prop: 'fddbrxm', label: '中国教育机构法定代表人姓名'}),
                new ListItem({prop: 'zwhzbxz', label: '中外合作办学者名称'}),
                new ListItem({prop: 'bxdz', label: '办学地址'}),
                new ListItem({prop: 'bxcc', label: '办学层次'}),
                new ListItem({prop: 'bxlx', label: '办学类型'}),
                new ListItem({prop: 'kszy_kc', label: '开设专业'}),
                new ListItem({prop: 'fzjg', label: '发证机关'}),
                new ListItem({prop: 'fzrq', label: '发证日期'}),
                new ListItem({prop: 'yxq', label: '有效期'})]
        }]
    },
    jytdwczwxkz: {
        title: "中外合作办学机构办学许可证查询",
        areaCode: "510000",
        labelWidth: null,
        key:'ea58d01769e842418354087676173628',
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '项目（机构）名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 120,
            colNum: 2,
            list: [
                new ListItem({prop: 'xkzbh', label: '许可证编号'}),
                new ListItem({prop: 'xmmc', label: '项名称'}),
                new ListItem({prop: 'fddbrxm', label: '中国教育机构法定代表人姓名'}),
                new ListItem({prop: 'zwhzbxz', label: '中外合作办学者名称'}),
                new ListItem({prop: 'bxdz', label: '办学地址'}),
                new ListItem({prop: 'bxcc', label: '办学层次'}),
                new ListItem({prop: 'bxlx', label: '有效期'}),
                new ListItem({prop: 'kszy_kc', label: '开设专业课程'}),
                new ListItem({prop: 'fzjg', label: '发证机关'}),
                new ListItem({prop: 'fzrq', label: '发证日期'}),
                new ListItem({prop: 'yxq', label: '有效期'})]
        }]
    },
    jytjjcsfyey: {
        title: "省级示范幼儿园查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 120, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'dq', label: '地区'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'bxlx', label: '办学类型'}),
                new ListItem({prop: 'dz', label: '地址'})]
        }]
    },
    jytjjcejpg: {
        title: "省二级示范高中查询",
        key:'8a623dbca3044df693b2489d61c5cef2',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'sz', label: '市州'}),
                new ListItem({prop: 'bh', label: '编号'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'bxxz', label: '办学性质'}),
                new ListItem({prop: 'qx', label: '区县'})]
        }]
    },
    jytjjcyjpg: {
        title: "省一级示范高中查询",
        key:'7bdb514c474340f49ff8858cbf86564a',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'sz', label: '市州'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'bxxz', label: '办学性质'}),
                new ListItem({prop: 'qx', label: '区县'})]
        }]
    },
    jytfzghcsenygz: {
        title: "十二年一贯制学校查询",
        key:'d455385a54c44ef5b3a270e8f77eeb64',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxxz', label: '办学性质'})]
        }]
    },
    jytfzghcjnygzxxxx: {
        title: "九年一贯制学校查询",
        areaCode: "510000",
        key:'7bc2cbbfcf85484f9eed3d9a8c8cd1d6',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxxz', label: '办学性质'})]
        }]
    },
    jytxsccrgdjyzk: {
        title: "成教专科学历信息查询",
        areaCode: "510000",
        key:'ab86e9b70f4a44fba32e4966a49bb088',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证书编号', prop: 'zsbh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'rxrq', label: '入学日期'}),
                new ListItem({prop: 'byrq', label: '毕业日期'}),
                new ListItem({prop: 'yxmc', label: '院校名称'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'xllb', label: '学历类别'}),
                new ListItem({prop: 'xz', label: '学制'}),
                new ListItem({prop: 'xxxs', label: '学习形式'}),
                new ListItem({prop: 'cc', label: '层次'}),
                new ListItem({prop: 'bjyjl', label: '毕结业结论'}),
                new ListItem({prop: 'xzm', label: '校长名'}),
                new ListItem({prop: 'zsbh', label: '证书编号'})]
        }]
    },
    jytxsccrgdjbk: {
        title: "成教本科学历信息查询",
        areaCode: "510000",
        key:'d19895afe30741998631ce979690c781',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证书编号', prop: 'zsbh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'rxrq', label: '入学日期'}),
                new ListItem({prop: 'byrq', label: '毕业日期'}),
                new ListItem({prop: 'yxmc', label: '院校名称'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'xllb', label: '学历类别'}),
                new ListItem({prop: 'sz', label: '学制'}),
                new ListItem({prop: 'xxxs', label: '学习形式'}),
                new ListItem({prop: 'cc', label: '层次'}),
                new ListItem({prop: 'bjyjl', label: '毕结业结论'}),
                new ListItem({prop: 'xzm', label: '校长名'}),
                new ListItem({prop: 'zsbh', label: '证书编号'})]
        }]
    },
    jytgjccrgdxljy: {
        title: "成教校外站点查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 200, list: [
                new ListItem({label: '学校名称或校外站点名称', prop: 'xxmcOrxwzdmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 120,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'crjyglbmdh', label: '成人教育管理部门咨询电话'}),
                new ListItem({prop: 'xwzdmc', label: '校外站点名称'}),
                new ListItem({prop: 'ytzdz', label: '依托站点单位名称'}),
                new ListItem({prop: 'dz', label: '地址'}),
                new ListItem({prop: 'fzrdh', label: '负责人姓名'}),
                new ListItem({prop: 'zxdh', label: '咨询电话'})]
        }]
    },
    jytfzghccrgdxxxx: {
        title: "成人高校查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxcc', label: '办学层次'}),
                new ListItem({prop: 'dsgx', label: '隶属关系'})]
        }]
    },
    jytsksyzczsgzdz: {
        title: "高职单招院校名单查询",
        areaCode: "510000",
        key:'6e91aa8194b944d0a85119c32b74bcbe',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '院校名称', prop: 'yxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'yxdm', label: '院校代码'}),
                new ListItem({prop: 'yxmc', label: '院校名称'}),
                new ListItem({prop: 'zgbm', label: '主管部门'}),
                new ListItem({prop: 'yxdz', label: '院校地址'}),
                new ListItem({prop: 'zsnd', label: '招生年度'}),
            ]
        }]
    },
    jytsksyscyjszs: {
        title: "研究生招生单位查询",
        key:'e0f6709de6a14a4fb03d45ad11272e07',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '单位名称', prop: 'dwmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'dwdm', label: '单位代码'}),
                new ListItem({prop: 'dwmc', label: '单位名称'}),
                new ListItem({prop: 'lxdh', label: '联系电话'}),
                new ListItem({
                    prop: 'sfzsbss', label: '是否招收博士生'
                })]
        }]
    },
    jytfzghcbkxxxx: {
        title: "本科学校查询",
        key:'7773f131182840dfb0865ddd7bb50211',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxcc', label: '办学层次'}),
                new ListItem({prop: 'dsgx', label: '隶属关系'}),
                new ListItem({prop: 'bz', label: '备注'})]
        }]
    },
    jytfzghczkxxxx: {
        title: "专科学校查询",
        key:'8bdd5dc4849443daa4f98638a3b09c0d',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxcc', label: '办学层次'}),
                new ListItem({prop: 'bz', label: '备注'})]
        }]
    },
    jytfzghcmbzk: {
        title: "民办专科查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxcc', label: '办学层次'}),
                new ListItem({prop: 'dsgx', label: '隶属关系'}),
                new ListItem({prop: 'bz', label: '备注'})]
        }]
    },
    jytfzghcmbczxxxx: {
        title: "民办初中查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'2891a5238b294beaa0f0e9d6d5cd89c1',
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxxz', label: '办学性质'})]
        }]
    },
    jytfzghcmbxqjy: {
        title: "民办学前教育学校查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'f422ece19a5e48d4b6dfef127260dcbb',
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxxz', label: '办学性质'})]
        }]
    },
    jytfzghcmbxx: {
        title: "民办小学查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'342a25e3c564401f8c3709a20fc24f20',
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxxz', label: '办学性质'})]
        }]
    },
    jytfzghcmbptgzx: {
        title: "民办普通高中查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'e3acf995fc4a41569b6b3b243d40d0de',
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxxz', label: '办学性质'})]
        }]
    },
    jytshmbcmbfxlg: {
        title: "高等教育机构信息查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'dz', label: '地址'}),
                new ListItem({prop: 'xz', label: '校长'}),
                new ListItem({prop: 'jbz', label: '举办者'}),
                new ListItem({prop: 'xxlx', label: '学校类型'}),
                new ListItem({prop: 'bxnr', label: '办学内容'}),
                new ListItem({prop: 'zgbm', label: '主管部门'}),
                new ListItem({prop: 'fzjg', label: '发证机关'})]
        }]
    },
    jytshmbcmbgdzk: {
        title: "民办专科办学许可证查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '名称', prop: 'mc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'mc', label: '名称'}),
                new ListItem({prop: 'dz', label: '地址'}),
                new ListItem({prop: 'xz', label: '校长'}),
                new ListItem({prop: 'bxxkzbh', label: '办学许可证编号'}),
                new ListItem({prop: 'xxlx', label: '学校类型'}),
                new ListItem({prop: 'bxnr', label: '办学内容'}),
                new ListItem({prop: 'zgbm', labell: '主管部门'}),
                new ListItem({prop: 'fzjg', labell: '发证机关'}),
                new ListItem({prop: 'yxqx', labell: '有效期限'})]
        }]
    },
    jytfzghcgbptgzxx: {
        title: "公办普通高中查询",
        key:'1cac49f55d48493ea8be6ecf9ebb572b',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxxz', label: '办学性质'})]
        }]
    },
    jytfzghcgbxqjyxx: {
        title: "公办学前教育学校查询",
        key:'8937b1c51bd54d7ea73ab27ac06385aa',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxxz', label: '办学性质'})]
        }]
    },
    jytfzghcgbzkxxxx: {
        title: "公办专科查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxcc', label: '办学层次'}),
                new ListItem({prop: 'dsgx', label: '隶属关系'}),
                new ListItem({prop: 'bz', label: '备注'})]
        }]
    },
    jytfzghcgbczxxxx: {
        title: "公办初中查询",
        areaCode: "510000",
    key:'7c8bfff67e344e88b1a755de98a08684',
    labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'bxxz', label: '办学性质'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'xxmc', label: '学校名称'})]
        }]
    },
    jytfzghcgbxxxxxx: {
        title: "公办小学查询",
        areaCode: "510000",
        key:'0ad60d60dc5e480a9c52769a6b2a1458',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 150, list: [
                new ListItem({label: '学校名称或所在地', prop: 'xxmcORszd', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'xxbsm', label: '学校标识码'}),
                new ListItem({prop: 'szd', label: '所在地'}),
                new ListItem({prop: 'bxxz', label: '办学性质'})]
        }]
    },
    jytjjcjcjyjxcgj: {
        title: "基础教育教学成果查询",
        key:'f81f3721fe124e538a563d4996256879',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 180, list: [
                new ListItem({label: '所属单位或项目名称', prop: 'ssdwOrxxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'sj', label: '时间'}),
                new ListItem({prop: 'xmmc', label: '项目名称'}),
                new ListItem({prop: 'wcry', label: '完成人员'}),
                new ListItem({prop: 'ssdw', label: '所属单位'}),
                new ListItem({prop: 'cgdj', label: '成果等级'})]
        }]
    },
    jytzjcjxcgjcx: {
        title: "教学成果奖（职教）查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '所在单位', prop: 'szdw', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'cgmc', label: '成果名称'}),
                new ListItem({prop: 'cgwcz', label: '成果完成者'}),
                new ListItem({prop: 'szdw', label: '所在单位'}),
                new ListItem({prop: 'cgdj', label: '成果等级'}),
                new ListItem({prop: 'hjnd', label: '获奖年度'})]
        }]
    },
    jytksycrgkcj: {
        title: "成人高考成绩查询",
        key:'6943226be0484ec39e3acc9f407fe267',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        transform: data => {
            if(!data.ResultBody)return []
            let obj = {}
            for (let i of data.ResultBody) {
                obj[i.Code] = i.Value
            }
            return [obj]
        },
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({
                    label: '考生号', prop: 'ksh',
                    comType: 'text',
                    edit: true,
                    required: true
                }),
                new ListItem({label: '准考证号', prop: 'zkzh', comType: 'text', edit: true, required: true}),
                new ListItem({label: '身份证号', prop: 'sfzh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'XM', label: '姓名'}),
                new ListItem({prop: 'BMH', label: '考生号'}),
                new ListItem({prop: 'KH', label: '准考证号'}),
                new ListItem({prop: 'YW', label: '语文'}),
                new ListItem({prop: 'WY', label: '外语'}),
                new ListItem({prop: 'SX', label: '数学（文科）'}),
                new ListItem({prop: 'ZF', label: '总分'}),
                new ListItem({prop: 'CXSJ', label: '查询时间'})]
        }]
    },
    jytksycrgklq: {
        title: "成人高考录取查询",
        areaCode: "510000",
        key:'c357c890d05a45cab997278940edc1f0',
        labelWidth: null,
        provenance: "",
        transform: data => {
            if(!data.ResultBody)return []
            let obj = {}
            for (let i of data.ResultBody) {
                obj[i.Code] = i.Value
            }
            return [obj]
        },
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({
                    label: '考生号', prop: 'ksh',
                    comType: 'text',
                    edit: true,
                    required: true
                }),
                new ListItem({label: '准考证号', prop: 'zkzh', comType: 'text', edit: true, required: true}),
                new ListItem({label: '身份证号', prop: 'sfzh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'XM', label: '姓名'}),
                new ListItem({prop: 'KSH', label: '考生号'}),
                new ListItem({prop: 'YXDM', label: '院校代码'}),
                new ListItem({prop: 'YXMC', label: '院校名称'}),
                new ListItem({prop: 'CCDM', label: '层次代码'}),
                new ListItem({prop: 'CC', label: '层次名称'}),
                new ListItem({prop: 'ZYDM', label: '专业代码'}),
                new ListItem({prop: 'ZYMC', label: '专业名称'}),
                new ListItem({prop: 'XXXSDM', label: '学习形式代码'}),
                new ListItem({prop: 'XXXS', label: '学习形式'}),
                new ListItem({prop: 'CXSJ', label: '查询时间'})]
        }]
    },
    jytksygkcjcx: {
        title: "普通高考成绩查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'50d0fcfd44604737a8779b1fc9b4875c',
        transform: data => {
            let obj = {}
            if(!data.ResultBody)return []
            for (let i of data.ResultBody) {
                obj[i.Code] = i.Value
            }
            return [obj]
        },
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({
                    label: '考生号', prop: 'ksh',
                    comType: 'text',
                    edit: true,
                    required: true
                }),
                new ListItem({label: '准考证号', prop: 'zkzh', comType: 'text', edit: true, required: true}),
                new ListItem({label: '身份证号', prop: 'sfzh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'XM', label: '姓名'}),
                new ListItem({prop: 'KSH', label: '考生号'}),
                new ListItem({prop: 'YW', label: '语文'}),
                new ListItem({prop: 'SX', label: '数学'}),
                new ListItem({prop: 'WY', label: '外语'}),
                new ListItem({prop: 'ZH', label: '理科综合'}),
                new ListItem({prop: 'ZZWL', label: '物理'}),
                new ListItem({prop: 'LSHX', label: '化学'}),
                new ListItem({prop: 'DLSW', label: '生物'}),
                new ListItem({prop: 'ZF', label: '总分'})]
        }]
    },
    jytksygklqcx: {
        title: "普通高考录取查询",
        areaCode: "510000",
        labelWidth: null,
        key:'c71f7e57b51b4b59bce09b1e1835a265',
        provenance: "",
        transform: data => {
            let obj = {}
            if(!data.ResultBody)return []
            for (let i of data.ResultBody) {
                obj[i.Code] = i.Value
            }
            return [obj]
        },
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({
                    label: '考生号', prop: 'ksh',
                    comType: 'text',
                    edit: true,
                    required: true
                }),
                new ListItem({label: '准考证号', prop: 'zkzh', comType: 'text', edit: true, required: true}),
                new ListItem({label: '身份证号', prop: 'sfzh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'XM', label: '姓名'}),
                new ListItem({prop: 'KSH', label: '考生号'}),
                new ListItem({prop: 'PCMC', label: '批次名称'}),
                new ListItem({prop: 'KLMC', label: '科类名称'}),
                new ListItem({prop: 'CCMC', label: '层次名称'}),
                new ListItem({prop: 'YXDH', label: '院校代码'}),
                new ListItem({prop: 'YXMC', label: '院校名称'}),
                new ListItem({prop: 'ZYDH', label: '专业代号'}),
                new ListItem({prop: 'ZYMC', label: '专业名称'}),
                new ListItem({prop: 'LQSJ', label: '录取时间'})]
        }]
    },
    jytksyzkcjcx: {
        title: "自学考试成绩查询",
        areaCode: "510000",
        key:'35200a5f870a45238ef3f9a1d3eed05e',
        labelWidth: null,
        provenance: "",
        transform: data => {
            if(!data.ResultBody)return []
            let obj = {}
            for (let i of data.ResultBody) {
                obj[i.Code] = i.Value
            }
            return [obj]
        },
        searchFields: [{
            labelWidth: 100,
            list: [
                new ListItem({label: '准考证号', prop: 'zkzh', comType: 'text', edit: true, required: true}),
                new ListItem({label: '身份证号', prop: 'sfzh', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 100,
            colNum: 2,
            list: [
                new ListItem({prop: 'XM', label: '姓名'}),
                new ListItem({prop: 'XB', label: '性别'}),
                new ListItem({prop: 'KCDM', label: '课程代码'}),
                new ListItem({prop: 'KCMC', label: '课程名称'}),
                new ListItem({prop: 'CJ', label: '成绩'})]
        }]
    },
    jytzzzxzzxx: {
        title: "学生受助信息查询",
        key:'87c6dfb665c8440fb98a0714264e48b5',
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 160,
            list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '身份证件号码', prop: 'zjhm', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'zjhm', label: '身份证件号码'}),
                new ListItem({prop: 'zzywmc', label: '资助业务名称'}),
                new ListItem({prop: 'xn', label: '学年'}),
                new ListItem({prop: 'xq', label: '学期'}),
                new ListItem({prop: 'zzje', label: '资助金额'})]
        }]
    },
    jytgzzbzxxyxjd: {
        title: "学生实践基地查询",
        areaCode: "510000",
        key:'639b78c1d3ee4067a9713ac6d4140f9c',
        labelWidth: null,
        provenance: "",
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '单位名称', prop: 'dwmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'dwmc', label: '单位名称'}),
                new ListItem({prop: 'frdb', label: '法人代表'}),
                new ListItem({prop: 'zgbm', label: '主管部门'}),
                new ListItem({prop: 'clsj', label: '成立时间'}),
                new ListItem({prop: 'dwxz', label: '单位性质'}),
                new ListItem({prop: 'sydx', label: '适宜对象'}),
                new ListItem({prop: 'zdmj', label: '占地面积（亩）'}),
                new ListItem({prop: 'jzmj', label: '建筑面积（㎡）'}),
                new ListItem({prop: 'rjdnl', label: '日接待能力（人）'}),
                new ListItem({prop: 'sscw', label: '宿舍床位（个）'}),
                new ListItem({prop: 'stcw', label: '食堂餐位（个）'}),
                new ListItem({prop: 'lxr', label: '联系人'}),
                new ListItem({prop: 'lxdh', label: '联系电话'}),
                new ListItem({prop: 'dzyx', label: '电子邮箱'}),
                new ListItem({prop: 'txdz', label: '通讯地址'}),
                new ListItem({prop: 'dwgk', label: '单位概况'}),
                new ListItem({prop: 'tskc', label: '特色课程'}),
                new ListItem({prop: 'kclb', label: '课程类别'}),
                new ListItem({prop: 'yxlx', label: '精品研学路线推荐'})]
        }]
    },
    jytgzzbqsnxwcs: {
        title: "青少年活动中心查询",
        areaCode: "510000",
        labelWidth: null,
        provenance: "",
        key:'0db6c60ccc0c48e7902c42bb325238bb',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '单位名称', prop: 'dwmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'dwmc', label: '单位名称'}),
                new ListItem({prop: 'frdb', label: '法人代表'}),
                new ListItem({prop: 'zgbm', label: '主管部门'}),
                new ListItem({prop: 'clsj', label: '成立时间'}),
                new ListItem({prop: 'dwxz', label: '单位性质'}),
                new ListItem({prop: 'dwlb', label: '单位类别'}),
                new ListItem({prop: 'sydx', label: '适宜对象'}),
                new ListItem({prop: 'zdmj', label: '占地面积（亩）'}),
                new ListItem({prop: 'jzmj', label: '建筑面积（㎡）'}),
                new ListItem({prop: 'rjdnl', label: '日接待能力（人）'}),
                new ListItem({prop: 'sscw', label: '宿舍床位（个）'}),
                new ListItem({prop: 'stcw', label: '食堂餐位（个）'}),
                new ListItem({prop: 'lxr', label: '联系人'}),
                new ListItem({prop: 'lxdh', label: '联系电话'}),
                new ListItem({prop: 'dzyx', label: '电子邮箱'}),
                new ListItem({prop: 'txdz', label: '通讯地址'}),
                new ListItem({prop: 'dwgk', label: '单位概况'}),
                new ListItem({prop: 'tskc', label: '特色课程'}),
                new ListItem({prop: 'kclb', label: '课程类别'})]
        }]
    },
    scsbsxwpygxcx: {
        title: "博士学位授予高校查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'5340fe249d7c4e67a4e3358c5a6c6ae9',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 120,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxdm', label: '学校代码'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'bxdz', label: '学校地址'}),
                new ListItem({prop: 'xxwz', label: '学校网址'}),
                new ListItem({prop: 'bxxz', label: '办学性质'}),
                new ListItem({prop: 'lsgx', label: '隶属关系'}),
                ]
        }]
    },
    scscrgdxljyxwzdcx: {
        title: "成教校外站点查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'70937fccc2074824a5a7bd1fa0b40d87',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称或校外站点名称', prop: 'xxmcOrxwzdmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'crjyglbmdh', label: '成人教育管理部门咨询电话'}),
                new ListItem({prop: 'xwzdmc', label: '校外站点名称'}),
                new ListItem({prop: 'ytzdz', label: '依托站点单位名称'}),
                new ListItem({prop: 'dz', label: '地址'}),
                new ListItem({prop: 'fzrdh', label: '负责人姓名'}),
                new ListItem({prop: 'zxdh', label: '咨询电话'}),
                ]
        }]
    },
    scsmbfxlgdjyjjbxxk: {
        title: "高等教育机构信息查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'58a9371f66844471b8695c86d542782f',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'dz', label: '地址'}),
                new ListItem({prop: 'xz', label: '校长'}),
                new ListItem({prop: 'jbz', label: '举办者'}),
                new ListItem({prop: 'xxlx', label: '学校类型'}),
                new ListItem({prop: 'bxnr', label: '办学内容'}),
                new ListItem({prop: 'zgbm', label: '主管部门'}),
                new ListItem({prop: 'fzjg', label: '发证机关'}),
                ]
        }]
    },
    scszwhzbxbkjghxm: {
        title: "本科中外合作办学查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'892844a482ce4a5cb4f2ed168cd78870',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '项目（机构）名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '项目（机构）名称（机构）名称'}),
                new ListItem({prop: 'pzsj', label: '项目批准日期'}),
                new ListItem({prop: 'zghzz', label: '中方合作者'}),
                new ListItem({prop: 'jbdd', label: '举办地点'}),
                new ListItem({prop: 'wfxx', label: '外方合作者及英文名称及世界排名情况'}),
                new ListItem({prop: 'gj', label: '国别(地区）(地区）'}),
                new ListItem({prop: 'cc', label: '层次'}),
                new ListItem({prop: 'zsfs', label: '招生方式'}),
                new ListItem({prop: 'zsrs', label: '批准每年招生人数'}),
                new ListItem({prop: 'lx', label: '类型'}),
                new ListItem({prop: 'zfzs', label: '中方证书'}),
                new ListItem({prop: 'wfzs', label: '外方证书'}),
                new ListItem({prop: 'zy', label: '学科(专业）'}),
                ]
        }]
    },
    scsmbgdzkxxbcxkcx: {
        title: "民办专科办学许可证查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'8662e7d6c99e40ea9f2ec209fa5bf7fd',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '名称', prop: 'mc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'mc', label: '名称（机构）名称（机构）名称'}),
                new ListItem({prop: 'dz', label: '地址'}),
                new ListItem({prop: 'xz', label: '校长'}),
                new ListItem({prop: 'bxxkzbh', label: '办学许可证编号'}),
                new ListItem({prop: 'xxlx', label: '学校类型'}),
                new ListItem({prop: 'bxnr', label: '办学内容(地区）(地区）'}),
                new ListItem({prop: 'zgbm', label: '主管部门'}),
                new ListItem({prop: 'fzjg', label: '发证机关'}),
                new ListItem({prop: 'yxqx', label: '有效期限'}),
                ]
        }]
    },
    scsgdzyxxndnzszycx: {
        title: "年度招生高职专业查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'8662e7d6c99e40ea9f2ec209fa5bf7fd',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称（机构）名称（机构）名称'}),
                new ListItem({prop: 'zydm', label: '专业名称'}),
                new ListItem({prop: 'zymc', label: '层次'}),
                new ListItem({prop: 'xynx', label: '专业类别'}),
                ]
        }]
    },
    scsqgxyzqxlycx: {
        title: "全国校园足球最佳阵容查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'76b2e5e0baec4e308b84baf527206193',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '身份证号', prop: 'sfzh', comType: 'text', edit: true, required: true})
                ]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'sfzh', label: '身份证号'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'rxsjdxx', label: '入选时就读学校'}),
                new ListItem({prop: 'rxnf', label: '入选年份'}),
                new ListItem({prop: 'rxzb', label: '入选组别'}),
                new ListItem({prop: 'sz', label: '市（州）'}),
                new ListItem({prop: 'ydydj', label: '运动员等级'})
                ]
        }]
    },
    scssjsfptgzcx: {
        title: "省级示范普通高中查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        suffix:'pc',
        key:'59348475c5f44783907f136af9c048e1',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'sz', label: '市州'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'bxxz', label: '办学性质'}),
                new ListItem({prop: 'qx', label: '区县'}),
                new ListItem({prop: 'jb', label: '级别'}),
                ]
        }]
    },
    scsyyyxjxcgjcx: {
        title: "教学成果奖（职教）查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'d0788917987b481eaad4fbe5de082ea8',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '所在单位', prop: 'szdw', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'cgmc', label: '成果名称'}),
                new ListItem({prop: 'cgwcz', label: '成果完成者'}),
                new ListItem({prop: 'szdw', label: '所在单位'}),
                new ListItem({prop: 'cgdj', label: '成果等级'}),
                new ListItem({prop: 'hjnd', label: '获奖年度'}),
                ]
        }]
    },
    scswjryznxxcx: {
        title: "外籍人员子女学校办学许可证查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'ac2935103dd645f2a30dfcf3031b3d38',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '项目（机构）名称', prop: 'xxmc', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'bxdz',label: '办学地址'}),
                new ListItem({prop: 'sfzsbx', label: '是否招生办学'}),
                new ListItem({prop: 'kbjg', label: '开办机构（个人）'}),
                new ListItem({prop: 'kbsj', label: '学校开办时间和审批部门（以批文为准）'}),
                new ListItem({prop: 'fr', label: '法定代表人（姓名、国籍）'}),
                new ListItem({prop: 'bxzz', label: '办学资金来源'}),
                new ListItem({prop: 'bxcc', label: '办学层次（幼儿园、小学、初中、高中）'}),
                new ListItem({prop: 'zxsrs', label: '现有在校学生数'}),
                new ListItem({prop: 'sysl', label: '生源数量排名前5国家'}),
                new ListItem({prop: 'zsqk', label: '否招收中国籍学生（含港澳台地区）'}),
                new ListItem({prop: 'jzgs', label: '教职工总数（注明非中国籍教职工人数）'}),
                new ListItem({prop: 'kskc', label: '开设课程（国别课程、国际课程等）'}),
                new ListItem({prop: 'yyzk', label: '学校运营状况及困难'}),
                ]
        }]
    },
    scsxyzqtsxxcx: {
        title: "校园足球校园特色查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'85442553655e47568c4dd6c97d14322b',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称或市（州）', prop: 'xxmcORsz', comType: 'text', edit: true, required: true})]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxch',label: '学校称号'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'hpnf', label: '获批年份'}),
                new ListItem({prop: 'sz', label: '市（州）'}),
                ]
        }]
    },
    scsxlxxcx: {
        title: "学历信息查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'d07be06089094f619773cf57e5a6ccc3',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证书编号', prop: 'zsbh', comType: 'text', edit: true, required: true}),
            ]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'rxrq', label: '入学日期'}),
                new ListItem({prop: 'byrq', label: '毕业日期'}),
                new ListItem({prop: 'yxmc', label: '院校名称'}),
                new ListItem({prop: 'zymc', label: '专业名称'}),
                new ListItem({prop: 'xllb', label: '学历类别'}),
                new ListItem({prop: 'xz', label: '学制'}),
                new ListItem({prop: 'xxxs', label: '学习形式'}),
                new ListItem({prop: 'cc', label: '层次'}),
                new ListItem({prop: 'bjyjl', label: '毕结业结论'}),
                new ListItem({prop: 'xzm', label: '校长名'}),
                new ListItem({prop: 'zsbh', label: '证书编号'}),
                ]
        }]
    },
    scszhyxctwhccjbcx: {
        title: "中华优秀传统文化传承基地查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'a4647b7603524a25a3e80f3c8a7e7ed3',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '学校名称或市（州）', prop: 'xxmcORsz', comType: 'text', edit: true, required: true}),
            ]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xxch', label: '学校称号'}),
                new ListItem({prop: 'xxmc', label: '学校名称'}),
                new ListItem({prop: 'hpnf', label: '获批年份'}),
                new ListItem({prop: 'sz', label: '市（州）'}),
                new ListItem({prop: 'ccxm', label: '传承项目'}),
                ]
        }]
    },
    scszwhzbxzkjghxmxxcx: {
        title: "中外合作办学项目批准书查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'021307496de749559823fd0d92da17f1',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '项目（机构）名称', prop: 'xmmc', comType: 'text', edit: true, required: true}),
            ]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'pzsbh', label: '许可证编号'}),
                new ListItem({prop: 'xmmc', label: '项名称'}),
                new ListItem({prop: 'fddbrxm', label: '中国教育机构法定代表人姓名'}),
                new ListItem({prop: 'zwhzbxz', label: '中外合作办学者名称'}),
                new ListItem({prop: 'bxdz', label: '办学地址'}),
                new ListItem({prop: 'bxcc', label: '办学层次'}),
                new ListItem({prop: 'bxlx', label: '办学类型'}),
                new ListItem({prop: 'kszy_kc', label: '开设专业'}),
                new ListItem({prop: 'fzjg', label: '发证机关'}),
                new ListItem({prop: 'fzrq', label: '发证日期'}),
                new ListItem({prop: 'yxq', label: '有效期'}),
                ]
        }]
    },
    scsxwxxcx: {
        title: "学位信息查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'5485e77d45144a14a448a13b84445dab',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证件号码', prop: 'zjhm', comType: 'text', edit: true, required: true}),
            ]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'mz', label: '民族'}),
                new ListItem({prop: 'csrq', label: '出生日期'}),
                new ListItem({prop: 'zjhm', label: '身份证号码'}),
                new ListItem({prop: 'xwsydwm', label: '学位授予单位码'}),
                new ListItem({prop: 'xwsydw', label: '学位授予单位名称'}),
                new ListItem({prop: 'xwlbm', label: '学位类别码'}),
                new ListItem({prop: 'xwlb', label: '学位类别名称'}),
                new ListItem({prop: 'rxny', label: '入学年月'}),
                new ListItem({prop: 'hxwrq', label: '获学位日期'}),
                new ListItem({prop: 'xwzsbh', label: '学位证书编号'}),
                ]
        }]
    },
    scsssyjsxyjxjhjcx: {
        title: "硕士研究生学业奖学金获奖名单查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'251fb486bf454460832a3141829d0dc6',
        searchFields: [{
            labelWidth: 125, list: [
                new ListItem({label: '获奖学生姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '获奖学生身份证号码', prop: 'sfzh', comType: 'text', edit: true, required: true}),
            ]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'sfzh', label: '获奖学生身份证号码'}),
                new ListItem({prop: 'hjnd', label: '获奖年度'}),
                new ListItem({prop: 'hjzsbh', label: '获奖证书编号'}),
                new ListItem({prop: 'zslkny', label: '证书落款年月'}),
                new ListItem({prop: 'hjdc', label: '获奖等次'}),
                ]
        }]
    },
    scsjypjggsyqcx: {
        title: "教育评价改革试验区查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'df9991474cd144288bd740b7463cabae',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '教育评价改革试验区', prop: 'dq', comType: 'text', edit: true, required: true}),
            ]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xh', label: '序号'}),
                new ListItem({prop: 'dq', label: '教育评价改革试验区'}),
                ]
        }]
    },
    scsjypjggsdgxcx: {
        title: "教育评价改革试点高校查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'2ed2b897e97843909fc56e9a575f371c',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '教育评价改革试验高校', prop: 'dq', comType: 'text', edit: true, required: true}),
            ]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xh', label: '序号'}),
                new ListItem({prop: 'dq', label: '教育评价改革试验高校'}),
                ]
        }]
    },
    scsgjlzjxjhjmdcx: {
        title: "国家励志奖学金获奖名单查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'763bb1afb0564bba886f4efc4e3809f2',
        searchFields: [{
            labelWidth: 100, list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证件号码', prop: 'zjhm', comType: 'text', edit: true, required: true}),
            ]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'sfzh', label: '获奖学生身份证号码'}),
                new ListItem({prop: 'hjxndqsnf', label: '获奖学年度起始年份'}),
                new ListItem({prop: 'hjxndjsnf', label: '获奖学年度结束年份'}),
                new ListItem({prop: 'hjzsbh', label: '获奖证书编号'}),
                new ListItem({prop: 'zslkny', label: '证书落款年月'}),
                ]
        }]
    },
    scsbsyjsxyjxjhjmd: {
        title: "博士研究生学业奖学金获奖名单查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'b79c045635774f049f847ba3377e8401',
        searchFields: [{
            labelWidth: 125, list: [
                new ListItem({label: '获奖学生姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '获奖学生身份证号码', prop: 'sfzh', comType: 'text', edit: true, required: true}),
            ]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'sfzh', label: '获奖学生身份证号码'}),
                new ListItem({prop: 'hjnd', label: '获奖年度'}),
                new ListItem({prop: 'hjzsbh', label: '获奖证书编号'}),
                new ListItem({prop: 'zslkny', label: '证书落款年月'}),
                new ListItem({prop: 'hjdc', label: '获奖等次'}),
                ]
        }]
    },
    scspthspcsdjcx: {
        title: "普通话水平测试等级查询",
        areaCode: "510000",
        labelWidth: null,
        unique:true,
        provenance: "",
        key:'d510d198bb0c4456a20fdc6ee6e12325',
        searchFields: [{
            labelWidth: 125, list: [
                new ListItem({label: '姓名', prop: 'xm', comType: 'text', edit: true, required: true}),
                new ListItem({label: '证件号码', prop: 'zjhm', comType: 'text', edit: true, required: true}),
            ]
        }],
        detailList: [{
            labelWidth: 160,
            colNum: 2,
            list: [
                new ListItem({prop: 'xm', label: '姓名'}),
                new ListItem({prop: 'xb', label: '性别'}),
                new ListItem({prop: 'zjhm', label: '身份证号'}),
                new ListItem({prop: 'fs', label: '分数'}),
                new ListItem({prop: 'level', label: '等级'}),
                new ListItem({prop: 'cszd', label: '测试站名称'}),
                new ListItem({prop: 'zsbh', label: '证书编号'}),
                new ListItem({prop: 'csrq', label: '测试日期'}),
                ]
        }]
    },
}
const keyFields={
    scsbsyjsxyjxjhjmd:'b79c045635774f049f847ba3377e8401',
    scsgjlzjxjhjmdcx:'763bb1afb0564bba886f4efc4e3809f2',
    scsjypjggsdgxcx:'2ed2b897e97843909fc56e9a575f371c',
    scsjypjggsyqcx:'df9991474cd144288bd740b7463cabae',
    scspthspcsdjcx:'d510d198bb0c4456a20fdc6ee6e12325',
    scsssyjsxyjxjhjcx:'251fb486bf454460832a3141829d0dc6',
    scsxwxxcx:'5485e77d45144a14a448a13b84445dab',
    //-----------20220113--------------------------
    scszwhzbxzkjghxmxxcx:'021307496de749559823fd0d92da17f1',
    scszhyxctwhccjbcx:'a4647b7603524a25a3e80f3c8a7e7ed3',
    scsxlxxcx:'d07be06089094f619773cf57e5a6ccc3',
    scsxyzqtsxxcx:'85442553655e47568c4dd6c97d14322b',
    scswjryznxxcx:'ac2935103dd645f2a30dfcf3031b3d38',
    scsyyyxjxcgjcx:'d0788917987b481eaad4fbe5de082ea8',
    scssjsfptgzcx:'59348475c5f44783907f136af9c048e1',
    scsqgxyzqxlycx:'76b2e5e0baec4e308b84baf527206193',
    scsgdzyxxndnzszycx:'7beceb1e048f4b97a06582900f3a3187',
    scsmbgdzkxxbcxkcx:'8662e7d6c99e40ea9f2ec209fa5bf7fd',
    scszwhzbxbkjghxm:'892844a482ce4a5cb4f2ed168cd78870',
    scsmbfxlgdjyjjbxxk:'58a9371f66844471b8695c86d542782f',
    scscrgdxljyxwzdcx:'70937fccc2074824a5a7bd1fa0b40d87',
    scsbsxwpygxcx:'5340fe249d7c4e67a4e3358c5a6c6ae9',

    jytttwycxyzqxlyzj:'5ff10ea852ef482885834de4b52b4ef6',
    jytjjcsfyey:'0cc1f259e3084d8ca6bd63ee00d3af61',
        jytzjcndzzjyzs:'62ce5c8d0a1948048d293b5c87a80fe0',
        jytgzzbqsnxwcs:'0db6c60ccc0c48e7902c42bb325238bb',
        jytrsjscsjjzyjy:'7f2f0841423c41ecb0cbd984adb5afc0',
        jytrsjscjybsf:'3c1f06e66d764e7daf814126c7d08b01',
        jytshmbcxwpxjg:'cf0501e738c14c5096c0212a3cc2e0ea',
        jytshmbcxwpxhmd:'10e6d275d5b647d1bb2c11044e0b125a',
        jytshmbcxwpxbmd:'37f8174279b74b16b31de22884e09c3a',
        jytsksyzczsptgd	:'8f8af436e2c3480aa98a11bfd65a3a54',
        jytksygklqcx	:'c71f7e57b51b4b59bce09b1e1835a265',
        jytksygkcjcx	:'50d0fcfd44604737a8779b1fc9b4875c',
        jytxscptbk	:'aa35e71b8c7f485fa89768e1b5374f4b',
        jytzjcndzzjy	:'c89d3f93b26348898d938705f73921ac',
        jytfzghcmbxqjy	:'f422ece19a5e48d4b6dfef127260dcbb',
        jytfzghcmbxx	:'342a25e3c564401f8c3709a20fc24f20',
        jytfzghcmbptgzx	:'e3acf995fc4a41569b6b3b243d40d0de',
        jytfzghcmbczxxxx	:'2891a5238b294beaa0f0e9d6d5cd89c1',
        jytkylxbkxsxw	:'48051e5855e14f51bcaa57552a909388',
        jytfzghcjnygzxxxx	:'7bc2cbbfcf85484f9eed3d9a8c8cd1d6',
        jytsksyjszgz	:'56a793bd15e04840950024bac9f951c7',
        jytjjcjcjyjxcgj	:'f81f3721fe124e538a563d4996256879',
        jytrsjscgjjzyjy	:'b2c88eddbe29448e97d50fdd8b496eee',
        jyttwycgfjytsxx	:'84715d0eab57424b9f03ec38626408d2',
        jytfzghcgbxqjyxx	:'8937b1c51bd54d7ea73ab27ac06385aa',
        jytfzghcgbxxxxxx	:'0ad60d60dc5e480a9c52769a6b2a1458',
        jytfzghcgbptgzxx	:'1cac49f55d48493ea8be6ecf9ebb572b',
        jytfzghcgbczxxxx	:'7c8bfff67e344e88b1a755de98a08684',
        jytsksyzczsgzdz	:'6e91aa8194b944d0a85119c32b74bcbe',
        jytjyzdzxscsgx	:'d58d84f8e73342e083df2e7c9db0dc8d',
        jytsksyzczscrgd	:'ad9dbc2a370b41719077db8592beba6c',
        jytksycrgklq	:'c357c890d05a45cab997278940edc1f0',
        jytksycrgkcj	:'6943226be0484ec39e3acc9f407fe267',
        jytkycrbkxsxw	:'94184aa2c85c48be886cf1fefa494510',
        jytxsccrgdjyzk	:'ab86e9b70f4a44fba32e4966a49bb088',
        jytxsccrgdjbk	:'d19895afe30741998631ce979690c781',
        jytkycbszyxw	:'6c79c50314ec4208943643caaad3f663',
        jytkycxljybs	:'1858e871d7a84107a4aeb6a2a155a348',
        jytxscbsyjsxlxx	:'b195d22d06f4415bb398be7cd6d4e9e0',
        jytfzghcbkxxxx	:'7773f131182840dfb0865ddd7bb50211',
        jytksyzkcjcx	:'35200a5f870a45238ef3f9a1d3eed05e',
        jytsksygdjyzxk	:'a1163b78dd144e89beaa127aaececeda',
        jytfzghczkxxxx	:'8bdd5dc4849443daa4f98638a3b09c0d',
        jytdwczwxkz	:'ea58d01769e842418354087676173628',
        jyttwycystsxx	:'7727e8aedd5d4a3e99f1564537015755',
        jytsksyscyjszs	:'e0f6709de6a14a4fb03d45ad11272e07',
        jytkycxszyxw	:'b8059332c58e46f4ad215ff772990674',
        jytkyptbkxsxw	:'73f155e2ba6b4600beaa918e060b353d',
        jytzzzxzzxx	:'87c6dfb665c8440fb98a0714264e48b5',
        jytgzzbzxxyxjd	:'639b78c1d3ee4067a9713ac6d4140f9c',
        jytxscwljyzk	:'dce20680996e4ec9acef4c16087982f5',
        jytxscwljybk	:'42016b35009842af97a8e23295505657',
        jytdwcwjznxx	:'444c6ab9404d4c9382f5a8320e3bee21',
        jytkyctdxlss	:'f972cd0e2461474580f549811ead0356',
        jytkyctdxlbs	:'9e93ae93c8ed4932ac104f4c950d2ea3',
        jyttwyctytsxx	:'786794ba9aff45c7a9d4ba6c5cd6e002',
        jytfzghctsjyxxxx	:'3bff4185d1fc44b1aebd4e28d5dc2659',
        jytkycsszyxw	:'4fd51fe527804142be03fa70b3c2126b',
        jytkycxljyss	:'a79614a6f0a04c9dba088c9bf1f279e6',
        jytxscssyjsxlxx	:'14a8a820f6404fa6bba15ebe8c7edcee',
        jytfzghcsenygz	:'d455385a54c44ef5b3a270e8f77eeb64',
        jytjjcyjpg	:'7bdb514c474340f49ff8858cbf86564a',
        jytzjcsszdzyxx	:'ce5b1fe4dc8b4727aca4f517fd08b483',
        jytjjcejpg	:'8a623dbca3044df693b2489d61c5cef2',}
const key=process.target,field = fields[key],keyId=keyFields[key]
field.appID = field.unique?key+(field.suffix||'app'):'scjytyybdsy'//key + (process.platform === 'mobile' ? 'app' : 'pc')
// console.log(JSON.stringify(Object.keys(keyFields)));
function test(){
    let keysXX={}
    Object.keys(keyFields).map(key1 =>{
        keysXX[key1]=fields[key1].title
    })
    console.log(JSON.stringify(keysXX));
}
// console.log(Object.keys(keyFields).join(' '));
// test()
export default field
export {keyId}